import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './InfoChip.module.css';
const InfoChip = ({ title, fields = [] }) => (_jsxs("dl", { children: [_jsx("dt", Object.assign({ className: styles.title }, { children: title }), void 0), fields &&
            fields.map((f, index) => (_jsx("dd", Object.assign({ className: styles.field }, { children: f }), `${title}-${index}`)))] }, void 0));
export default InfoChip;
